/**
 * One-click diagnostics block for bug reports.
 *
 * Lives here rather than in version.ts so version.ts stays a dependency-free
 * leaf (config.ts imports it — importing config back would be circular).
 */

import { config } from './config';
import { RELEASED, VERSION } from './version';

/** Plain-text build + environment summary, copied from the profile menu. */
export function buildInfoText(): string {
  const lines = [
    `FLYsafe v${VERSION}`,
    `Released:    ${RELEASED}`,
    `Tenant:      ${config.tenant.id} (${config.tenant.label})`,
    `Data source: ${config.dataSource}`,
    `MQTT schema: ${config.mqtt.schema}`,
  ];
  if (typeof navigator !== 'undefined') lines.push(`Browser:     ${navigator.userAgent}`);
  if (typeof location !== 'undefined')
    lines.push(`URL:         ${location.origin}${location.pathname}`);
  return lines.join('\n');
}
